export default __webpack_public_path__ + "static/media/Kategori Produk-SMART STORAGE-2.e99a92e3.jpg";